// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divGl {
    width: 100%;
    /* display: flex; */
}

.tableauT td:first-child {
  border-right: none !important;
}

/* .tableauT td { */
  /* border: 1.5px solid #000; */
/* } */



/* CSS POUR PARTAGE FORMULAIRE */
.divGB {
  width: 100%;
}
.colIcons {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-gap: 15%;
  margin-top: 5%;
}
.divMessage {
  /* background-color: red;  #43CE0C*/
  font-size:18px;
}
.iconMessage {
  background-color: #43CE0C; 
  padding:20%;
  font-size:30px;
  border-radius:1rem;
  color: #fff;
}
.iconMeil {
  background-color: #43CE0C; 
  padding:26%;
  font-size:32px;
  border-radius:1rem;
  color: #fff;
}


/* CSS DU COMPOSANT FORMPREVIEW */
.divGFormPrv {
  width: 100%;
}
.stylDivTop {
  background-color: #fff;
  padding: 1%;
  margin-top: -1%;
}
.stylColRight {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5%;
}
.stylDivContent {
  background-color: #E8FCE2;
  height:auto ;
  min-height: 100vh;
}
.stylCardTitleDesc {
  border-top: 10px solid #43CE0C;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  margin-bottom: 15px;
}
 /* border: #E8FCE2; */


/* CSS POUR DETAILSFORM */
.stylCopyText .ant-typography-copy {
  font-size: 24px;
  color: #43CE0C;
  float: right;
}




/* CSS POUR REPONSESVIEWFORM */
.stylDivGlobl {
  width: 100%;
  margin-top: 2%;
}
.stylDivRenderC {
  margin-top: 3%;
   border-radius: 1rem;
}

.stylMenuGlobal {
  border-bottom: none; 
  margin-bottom: -2.5%;
  /* color: #43CE0C; */
   display: flex !important;
  justify-content: center !important;
}
.stylMenuGlobal .ant-menu-item {
  margin: 0 10%;
}
/* .stylMenuGlobal .ant-menu-item-selected {
  color: #43CE0C !important;       
  border-bottom: 3px solid #43CE0C !important; 
}
.stylMenuGlobal.ant-menu-horizontal > .ant-menu-item::after,
.stylMenuGlobal .ant-menu-horizontal > .ant-menu-submenu::after {
  border-bottom: none !important;
} */

.stylCardReponse {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  /* border-top-left-radius: 0 !important;
border-top-right-radius: 0 !important;
border-bottom-right-radius: 0 !important; 
border-bottom-left-radius: 0 !important; */
}

  .card-to-print {
  margin-bottom: 15px !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
 .card-to-printR {
  margin-bottom: 15px !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}



`, "",{"version":3,"sources":["webpack://./src/pages/formulaires/formulaires.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,mBAAmB;EACjB,8BAA8B;AAChC,MAAM;;;;AAIN,gCAAgC;AAChC;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;;AAGA,iCAAiC;AACjC;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,OAAO;AACT;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,wDAAwD;EACxD,mDAAmD;EACnD,mBAAmB;AACrB;CACC,qBAAqB;;;AAGtB,yBAAyB;AACzB;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;;;;AAKA,8BAA8B;AAC9B;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,cAAc;GACb,mBAAmB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;GACnB,wBAAwB;EACzB,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AACA;;;;;;;GAOG;;AAEH;EACE,wCAAwC;EACxC;;;0CAGwC;AAC1C;;EAEE;EACA,8BAA8B;EAC9B,wCAAwC;AAC1C;CACC;EACC,8BAA8B;EAC9B,wCAAwC;AAC1C","sourcesContent":[".divGl {\r\n    width: 100%;\r\n    /* display: flex; */\r\n}\r\n\r\n.tableauT td:first-child {\r\n  border-right: none !important;\r\n}\r\n\r\n/* .tableauT td { */\r\n  /* border: 1.5px solid #000; */\r\n/* } */\r\n\r\n\r\n\r\n/* CSS POUR PARTAGE FORMULAIRE */\r\n.divGB {\r\n  width: 100%;\r\n}\r\n.colIcons {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  grid-gap: 15%;\r\n  margin-top: 5%;\r\n}\r\n.divMessage {\r\n  /* background-color: red;  #43CE0C*/\r\n  font-size:18px;\r\n}\r\n.iconMessage {\r\n  background-color: #43CE0C; \r\n  padding:20%;\r\n  font-size:30px;\r\n  border-radius:1rem;\r\n  color: #fff;\r\n}\r\n.iconMeil {\r\n  background-color: #43CE0C; \r\n  padding:26%;\r\n  font-size:32px;\r\n  border-radius:1rem;\r\n  color: #fff;\r\n}\r\n\r\n\r\n/* CSS DU COMPOSANT FORMPREVIEW */\r\n.divGFormPrv {\r\n  width: 100%;\r\n}\r\n.stylDivTop {\r\n  background-color: #fff;\r\n  padding: 1%;\r\n  margin-top: -1%;\r\n}\r\n.stylColRight {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 5%;\r\n}\r\n.stylDivContent {\r\n  background-color: #E8FCE2;\r\n  height:auto ;\r\n  min-height: 100vh;\r\n}\r\n.stylCardTitleDesc {\r\n  border-top: 10px solid #43CE0C;\r\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\r\n  font-family: 'Roboto', Helvetica, Arial, sans-serif;\r\n  margin-bottom: 15px;\r\n}\r\n /* border: #E8FCE2; */\r\n\r\n\r\n/* CSS POUR DETAILSFORM */\r\n.stylCopyText .ant-typography-copy {\r\n  font-size: 24px;\r\n  color: #43CE0C;\r\n  float: right;\r\n}\r\n\r\n\r\n\r\n\r\n/* CSS POUR REPONSESVIEWFORM */\r\n.stylDivGlobl {\r\n  width: 100%;\r\n  margin-top: 2%;\r\n}\r\n.stylDivRenderC {\r\n  margin-top: 3%;\r\n   border-radius: 1rem;\r\n}\r\n\r\n.stylMenuGlobal {\r\n  border-bottom: none; \r\n  margin-bottom: -2.5%;\r\n  /* color: #43CE0C; */\r\n   display: flex !important;\r\n  justify-content: center !important;\r\n}\r\n.stylMenuGlobal .ant-menu-item {\r\n  margin: 0 10%;\r\n}\r\n/* .stylMenuGlobal .ant-menu-item-selected {\r\n  color: #43CE0C !important;       \r\n  border-bottom: 3px solid #43CE0C !important; \r\n}\r\n.stylMenuGlobal.ant-menu-horizontal > .ant-menu-item::after,\r\n.stylMenuGlobal .ant-menu-horizontal > .ant-menu-submenu::after {\r\n  border-bottom: none !important;\r\n} */\r\n\r\n.stylCardReponse {\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  /* border-top-left-radius: 0 !important;\r\nborder-top-right-radius: 0 !important;\r\nborder-bottom-right-radius: 0 !important; \r\nborder-bottom-left-radius: 0 !important; */\r\n}\r\n\r\n  .card-to-print {\r\n  margin-bottom: 15px !important;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n}\r\n .card-to-printR {\r\n  margin-bottom: 15px !important;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
